import { useState, useEffect } from 'react'

export const useDarkMode = () => {
  const [isDarkMode, setIsDarkMode] = useState(false)

  useEffect(() => {
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

    const handleDarkModeChange = (event) => {
      setIsDarkMode(event.matches)
    }

    darkModeMediaQuery.addEventListener('change', handleDarkModeChange)
    setIsDarkMode(darkModeMediaQuery.matches)

    return () => {
      darkModeMediaQuery.removeEventListener('change', handleDarkModeChange)
    }
  }, [])

  return { isDarkMode }
}
